import { q, qq } from "../../helper/q"

export const mobileProductInit = () => {
  const availabilityElements = qq(".availability")
  availabilityElements.map(availabilityElement => {
    const availabilityButton = q(".availabilityMain", availabilityElement)
    const availabilityButtonIcon = q(".availabilityButton", availabilityElement)
    const availabilityContent = q(".availabilityContent", availabilityElement)
    availabilityButton.addEventListener("click", () => {
      availabilityContent.classList.toggle("availabilityContentVisible")
      availabilityButtonIcon.classList.toggle("availabilityButtonActive")
    })
  })

  const optionsElements = qq(".optionsRow")

  optionsElements.map(optionsElement => {
    const optionsElementTrigger = q(".optionsCellPackaging", optionsElement)
    const optionsElementButton = q(".optionsPackagingButton", optionsElement)
    const optionsElementContent = q(".optionsDetailsMobile", optionsElement)
    optionsElementTrigger.addEventListener("click", () => {
      optionsElementContent.classList.toggle("optionsDetailsMobileVisible")
      optionsElementButton.classList.toggle("optionsPackagingButtonActive")
    })
  })

  const filterMobileButton = q(".productsFilterLogo")
  if (filterMobileButton) {
    filterMobileButton.addEventListener("click", () => {
      q(".productsFilterForm").classList.toggle("productsFilterFormActive")
    })
  }
}
